/**
 * @Description: 摇一摇效果迁移调整
 * @method
 * @author fierayan
 * @date 2022/12/9 11:39
 */

import anime from 'animejs/lib/anime.es.js';

let ShakeAnimation = {
  guide: function(
    shakeLogoSelector,
    offsetLeft,
    offsetRight,
    duration = 500,
    easing = 'easeInOutQuad'
  ) {
    let guideObject = {
      targets: shakeLogoSelector,
      keyframes: [
        { rotate: 0 },
        { rotate: -offsetLeft },
        { rotate: 0 },
        { rotate: offsetRight },
        { rotate: 0 }
      ],
      loop: 3,
      duration: duration,
      easing: easing,
      delay: 1000
    };

    return anime(guideObject);
  },
  action: function(shakeFrontBox, offset, duration = 500, easing = 'easeInOutCubic') {
    return new Promise((resolve) => {
      let shakeUpAniObject = {
        targets: shakeFrontBox + '>.shake__up',
        translateY: [0, -offset],
        direction: 'alternate',
        duration: duration,
        easing: easing,
        complete: function() {
          anime.set(shakeFrontBox + ' .shake__border', {
            opacity: 0
          });
          resolve('shake action done');
        }
      };
      let shakeDownAniObject = {
        targets: shakeFrontBox + '>.shake__down',
        translateY: [0, offset],
        direction: 'alternate',
        duration: duration,
        easing: easing
      };
      anime({
        targets: ' .shake__animation-box',
        opacity: 0,
        duration: 100,
        easing: 'linear'
      });
      anime({
        targets: shakeFrontBox + ' .shake__border',
        opacity: 1,
        duration: 100,
        easing: 'linear'
      });
      anime({
        targets: shakeFrontBox + ' .shake__half',
        opacity: 1,
        duration: 100,
        easing: 'linear'
      });
      anime(shakeUpAniObject);
      anime(shakeDownAniObject);
    });
  },
  recover(shakeFrontBox) {
    return new Promise((resolve) => {
      anime.set('.shake__animation-box', {
        opacity: 1
      });
      anime.set(shakeFrontBox + ' .shake__half', {
        opacity: 0
      });
      resolve();
    });
  }
};

export default ShakeAnimation;
